/* assets/pickup-date.js — Signatur Bio Marché
   Afhentningsdag i kurven. Al konfiguration kommer fra window.PICKUP_DATE,
   som sættes af snippets/pickup-date-config.liquid.

   Ligger i en selvstændig fil, fordi Kalles genrenderer kurven med AJAX —
   inline scripts i udskiftet HTML kører ikke igen.
*/
(function () {
  'use strict';

  var CFG = window.PICKUP_DATE;
  if (!CFG) return;

  var ATTR = 'Afhentningsdato';
  var CHECKOUT_SEL = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    '.t4s-btn__checkout',
    '.shopify-payment-button__button',
    'a[href*="/checkout"]'
  ].join(',');

  var root   = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var values = CFG.options.map(function (o) { return o.value; });
  var chosen = CFG.chosen || '';
  var saving = false;

  /* Låsen gælder KUN når kurven faktisk indeholder en forudbestillingsvare,
     og der er mindst én åben dag at vælge imellem. Køber man kun almindelige
     varer — hudpleje, kaffe, pålæg — sker der ingenting. */
  function mustChoose() {
    return CFG.required === true && values.length > 0 && !chosen;
  }

  /* Hvornår skal vælgeren overhovedet tegnes?
     - required  : kurven indeholder en forudbestillingsvare (kurvesiden)
     - onProduct : vi står på selve forudbestillingsvarens produktside,
                   også selvom kurven er tom — så kan kunden vælge dagen,
                   inden hun trykker Pre-order.
     Låsen af betalingsknappen følger stadig KUN kurven, jf. mustChoose(). */
  function shouldShow() {
    return (CFG.required === true || CFG.onProduct === true) && values.length > 0;
  }

  function mounts()  { return document.querySelectorAll('[data-pickup-mount]'); }
  function pickers() { return document.querySelectorAll('[data-pickup-date]'); }

  /* Stilarter lægges ind herfra, så snippet'et pickup-date.liquid er valgfrit. */
  var CSS = ''
    /* Alt i px, ikke rem: Kalles sætter html{font-size:10px}, så rem-værdier
       skrumper til to tredjedele af det, man forventer. 1rem ville give 10px. */
    + '.pickup-date{margin:20px 0;padding:16px 18px;border:1px solid rgba(0,0,0,.14);border-radius:8px}'
    + '.pickup-date__title{margin:0 0 5px!important;font-size:17px!important;line-height:1.35!important;font-weight:600!important}'
    + '.pickup-date__help{margin:0 0 12px!important;font-size:14px!important;line-height:1.5!important;opacity:.8}'
    + '.pickup-date__options{display:flex;flex-direction:column;gap:2px}'
    + '.pickup-date__option{display:flex!important;align-items:center!important;gap:10px!important;flex-wrap:nowrap!important;padding:7px 9px;margin:0 -9px;border-radius:5px;cursor:pointer}'
    + '.pickup-date__option:hover{background:rgba(0,0,0,.035)}'
    /* Kalles giver ALLE input-felter fuld bredde, 40px hoejde og appearance:none.
       Uden de her !important-regler bliver radioknappen et 1143px tekstfelt,
       og dagteksten bliver skubbet helt uden for kassen. */
    + '.pickup-date__option input[type="radio"]{-webkit-appearance:radio!important;appearance:radio!important;'
    + 'width:16px!important;height:16px!important;min-width:16px!important;max-width:16px!important;'
    + 'min-height:16px!important;max-height:16px!important;flex:0 0 16px!important;'
    + 'margin:0!important;padding:0!important;border:0!important;background:none!important;'
    + 'box-shadow:none!important;border-radius:50%!important;display:inline-block!important;'
    + 'line-height:normal!important;accent-color:#2b6b3f}'
    + '.pickup-date__option span{flex:1 1 auto!important;display:inline-block!important;width:auto!important;font-size:15px!important;line-height:1.4!important}'
    + '.pickup-date__msg{margin:11px 0 0!important;font-size:14px!important;line-height:1.45!important;color:#b3261e}'
    + '.pickup-date.is-saving{opacity:.55;pointer-events:none}'
    + '.pickup-date.is-missing{border-color:#b3261e}';

  function injectCss() {
    if (document.getElementById('pickup-date-css')) return;
    var s = document.createElement('style');
    s.id = 'pickup-date-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* --- gem i kurven ------------------------------------------------------ */

  function save(value) {
    saving = true;
    pickers().forEach(function (p) { p.classList.add('is-saving'); });

    var payload = { attributes: {} };
    payload.attributes[ATTR] = value;

    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/update fejlede: ' + res.status);
        chosen = value || '';
      })
      .catch(function (err) {
        if (window.console) console.warn('[pickup-date]', err);
      })
      .then(function () {
        saving = false;
        pickers().forEach(function (p) { p.classList.remove('is-saving'); });
        paint();
      });
  }

  // Har kunden en dato med fra sidste besøg som ikke længere gælder?
  // (fx fredagsfristen er passeret, så ugen er rykket videre)
  if (chosen && values.indexOf(chosen) === -1) {
    chosen = '';
    save('');
  }

  // Forvalgt dag, hvis butikken har sat pickup_default i config-snippet'et.
  // Står den tom — som anbefalet — sker der ingenting her.
  if (!chosen && CFG.defaultValue && values.indexOf(CFG.defaultValue) > -1) {
    save(CFG.defaultValue);
  }

  /* --- tegn vælgeren ----------------------------------------------------- */

  function markup() {
    var opts = CFG.options.map(function (o) {
      return '<label class="pickup-date__option">'
           + '<input type="radio" name="pickup-date" value="' + o.value + '">'
           + '<span>' + o.label + '</span></label>';
    }).join('');

    return '<div class="pickup-date" data-pickup-date>'
      + '<h3 class="pickup-date__title">Vælg din afhentningsdag</h3>'
      + '<p class="pickup-date__help">Bestil senest ' + CFG.deadline
      + ', så står din kasse klar i ' + CFG.address + '.</p>'
      + '<div class="pickup-date__options">' + opts + '</div>'
      + '<p class="pickup-date__msg" data-pickup-msg hidden>'
      + 'Vælg en afhentningsdag, før du går til betaling.</p>'
      + '<input type="hidden" name="attributes[' + ATTR + ']" value="" data-pickup-mirror>'
      + '</div>';
  }

  /* Findes der intet monteringspunkt — dvs. snippet'et pickup-date.liquid er
     ikke lagt ind i kurvesektionen — laver vi selv et. Så virker vælgeren
     uden at røre Kalles' sektionsfiler overhovedet. Vil du styre placeringen
     præcist, så indsæt {% render 'pickup-date' %} hvor du vil have den; så
     springer koden herunder over. */
  function ensureMount() {
    if (mounts().length) return;

    function placer(host) {
      if (!host) return;
      var el = document.createElement('div');
      el.setAttribute('data-pickup-mount', '');
      host.insertBefore(el, host.firstChild);
    }

    /* Kurvesiden: vis når kurven indeholder en forudbestillingsvare. */
    var cartHost = document.querySelector('.t4s-cartPage__footer')
                || document.querySelector('.t4s-cartPage__form');
    if (cartHost) {
      if (CFG.required === true) placer(cartHost);
      return;
    }

    /* Produktsiden: KUN på selve forudbestillingsvaren.
       Uden det her tjek ville vælgeren dukke op på alle 250 produktsider,
       så snart kunden havde en kasse liggende i kurven — produktsidens
       add-to-cart-formular peger nemlig også på /cart/add. */
    if (CFG.onProduct !== true) return;
    placer(document.querySelector('form[data-type="add-to-cart-form"]')
        || document.querySelector('form[action*="/cart/add"]'));
  }

  function mount() {
    if (!shouldShow()) return;
    ensureMount();
    mounts().forEach(function (el) {
      if (el.querySelector('[data-pickup-date]')) return;   // allerede monteret
      el.innerHTML = markup();
    });
  }

  function paint() {
    var missing = mustChoose();

    pickers().forEach(function (p) {
      p.classList.toggle('is-missing', missing);
      p.querySelectorAll('input[name="pickup-date"]').forEach(function (i) {
        i.checked = (i.value === chosen);
      });
      var msg = p.querySelector('[data-pickup-msg]');
      if (msg) msg.hidden = !missing;
    });

    document.querySelectorAll('[data-pickup-mirror]').forEach(function (el) {
      el.value = chosen;
    });

    document.querySelectorAll(CHECKOUT_SEL).forEach(function (btn) {
      if (btn.tagName === 'A') return;              // links kan ikke disables
      var lock = missing || (saving && CFG.required === true);
      btn.disabled = lock;
      btn.setAttribute('aria-disabled', lock ? 'true' : 'false');
      btn.style.opacity = lock ? '.5' : '';
      btn.style.cursor  = lock ? 'not-allowed' : '';
    });
  }

  /* --- events ------------------------------------------------------------ */

  document.addEventListener('change', function (e) {
    if (!e.target || e.target.name !== 'pickup-date') return;
    save(e.target.value);
  });

  // Capture-fasen fanger også knapper som mini-kurven indsætter bagefter.
  document.addEventListener('click', function (e) {
    if (!mustChoose()) return;
    var btn = e.target.closest ? e.target.closest(CHECKOUT_SEL) : null;
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var picker = pickers()[0];
    if (picker && picker.offsetParent !== null) {
      picker.classList.add('is-missing');
      var msg = picker.querySelector('[data-pickup-msg]');
      if (msg) msg.hidden = false;
      picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      // Klikket kom fra mini-kurven, hvor vælgeren ikke findes.
      window.location.href = CFG.cartUrl || (root + 'cart');
    }
  }, true);

  // Kalles genrenderer kurven med AJAX — hold vælger og lås ved lige.
  var observer = new MutationObserver(function () {
    if (saving) return;
    mount();
    paint();
  });

  function boot() {
    injectCss();
    mount();
    paint();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
